import { FC } from 'react';
import PinInput from 'react-pin-input';
import palette from '../../../shared/lib/theme/palette';
import { PinInputWrapper } from '../../../shared/lib/theme/styleComponents';
import { useAppContext } from '../app/contexts/AppContext';
import { CustomPinInputProps } from '../app/interfaceTypes';
import { Timer } from './common/Timer';
import { scrollToTop } from '../../../shared/lib/utils';
import { MSG_OTP_EXPIRED, MSG_OTP_EXPIRES_IN } from '../../../shared/lib/constants';
import { useMobileView } from '../app/hooks/useMobileView';

export const CustomPinInput: FC<CustomPinInputProps> = ({ onComplete: onCompletePin, onChange, pinRef, infoSteps, timer, mb }) => {
  const { borderLight } = palette;
  const { timeLeft } = useAppContext();
  const mediumViewport = useMobileView();

  return (
    <PinInputWrapper textAlign="center" mb={mb ?? '24px'}>
      <PinInput
        length={6}
        focus={true}
        initialValue=""
        type="numeric"
        inputMode="number"
        style={{ padding: '10px' }}
        inputStyle={{ borderColor: borderLight }}
        inputFocusStyle={{ borderColor: borderLight }}
        onComplete={(value) => {
          onCompletePin?.(value);

          if (mediumViewport) {
            const field = document.createElement('input');
            field.setAttribute('type', 'text');
            field.style.position = 'fixed';
            field.style.left = '-9999px';
            field.style.top = '-9999px';
            document.body.appendChild(field);

            setTimeout(function () {
              field.focus();

              setTimeout(function () {
                field.blur();
                field.remove();
              }, 50);
            }, 50);

            scrollToTop();
          }
        }}
        autoSelect={true}
        onChange={onChange}
        ref={pinRef}
        regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
      />

      {timer && <Timer title={timeLeft === 0 ? MSG_OTP_EXPIRED : MSG_OTP_EXPIRES_IN} infoSteps={infoSteps!} />}
    </PinInputWrapper>
  );
};
